import request from 'utils/request'
import authRequest from 'utils/authRequest'
import corporateRequest from 'utils/corporateRequest'
import adminRequest from 'utils/adminRequest'
import instituteRequest from 'utils/instituteRequest'
import studentRequest from 'utils/studentRequest'
import candidateRequest from 'utils/candidateRequest'
import { installSessionRefresh } from 'utils/sessionRefresh'
import { SignInSuccess } from 'modules/Auth/actions'

const initApiServices = store => {
  try {
    installSessionRefresh({
      umsRequest: request,
      instances: [
        request,
        authRequest,
        corporateRequest,
        adminRequest,
        instituteRequest,
        studentRequest,
        candidateRequest,
      ],
      onToken: token => store.dispatch(SignInSuccess(token)),
    })
    request.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error?.response?.statusText === 'Unauthorized') {
          localStorage.clear()
          location.reload()
          return new Promise(() => {})
        } else {
          return Promise.reject(new Error(error))
        }
      }
    )
  } catch (e) {
    console.error('Error occurred while logout : in InitApiService', e)
  }
}

export default initApiServices
